import { Product } from '@/types/api/api-v3/product'

/**
 * Формализация наименования продукта
 * @param product - данные продукта
 */
export const formatToTitleOfProduct = (product: Product) =>
  product.modifications[0].mode
    ? `${product.name} ${product.modifications[0].mode}`
    : `${product.name}`
